import useAsyncEffect from "use-async-effect";
import axios from "axios";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import React, {useState} from "react";
import Card from "../../../../components/card";
import CustomPagination from "../../../../components/CustomPagination/CustomPagination";
import {utils, writeFile} from "xlsx";
import PieChart from "../../../../components/charts/PieChart";

const LocationDataStatePieChart = () => {

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";
    let [selectedValue, setSelectedValue] = useState("State")

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();
    const [locationJsonResult, setLocationJsonResult] = useState([]);
    const [pg, setpg] = useState(0);
    const [rpg, setrpg] = useState(5);
    let [total, setTotal] = useState(0)
    let [isLoading, setIsLoading] = useState(true)
    let [dataCount, setDataCount] = useState([]);
    let [options, setOptions] = useState([]);
    const [pieChartDataValues, setPieChartData] = useState([]);
    const [unit, setUnits] = useState([]);

    function getCurrentDate(){
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Jan is 0!
        const year = today.getFullYear();

        return `${day}-${month}-${year}`
    }

    function handleChangePage(event, newpage) {
        setpg(newpage);
    }

    function handleChangeRowsPerPage(event) {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    function getLocationDemographicsByState() {
        var url = CROMPTON_ANALYTICS_URL + "v1/user/location/states"
        axios({
            method: "GET", url: url, headers: {
                Authorization: decryptedValue,
            }

        }).then((res) => {
            let totalNumber = 0
            //console.log(res.data)

            var state = []
            var count = [];

            let newResult = res.data.slice().sort((a, b) => b.count - a.count);

            for (var i = 0; i < newResult.length; i++) {
                state.push(newResult[i].state);
                count.push(newResult[i].count);
                totalNumber = totalNumber + newResult[i].count
            }

            setOptions(state)
            options = state
            setDataCount(count)
            dataCount = count

            setPieChartData(count);
            setUnits(state)

            setLocationJsonResult(res.data)
            setTotal(totalNumber)
            setIsLoading(false)

        }).catch((error) => {
            setIsLoading(false)
           // console.log(error)
            if (error.response.data.status === "401" || error.response.data.status === "403") {
                handleLogOut();
            }
        })

    }

    function getLocationDemographicsByCity() {
        var url = CROMPTON_ANALYTICS_URL + "v1/user/location/cities"
        axios({
            method: "GET", url: url, headers: {
                Authorization: decryptedValue,
            }

        }).then((res) => {
            let totalNumber = 0
            //console.log(res.data)

            var state = []
            var count = [];
            let newResult = res.data.slice().sort((a, b) => b.count - a.count);

            for (var i = 0; i < newResult.length; i++) {
                state.push(newResult[i].city);
                count.push(newResult[i].count);
                totalNumber = totalNumber + newResult[i].count
            }

            setOptions(state)
            options = state
            setDataCount(count)
            dataCount = count

            setPieChartData(count);
            setUnits(state)

            setLocationJsonResult(res.data)
            setTotal(totalNumber)
            setIsLoading(false)

        }).catch((error) => {
            setIsLoading(false)
            //console.log(error)
            if (error.response.data.status === "401" || error.response.data.status === "403") {
                handleLogOut();
            }
        })

    }

    useAsyncEffect(async () => {
            getLocationDemographicsByState()

        }, [selectedValue]
    );

    function handleStateCityDropDown() {
        const selectBox = document.getElementById("stateCityBoxBarChart")
        selectedValue = selectBox.options[selectBox.selectedIndex].value
        setSelectedValue(selectBox.options[selectBox.selectedIndex].value)

        if (selectedValue === "State" || selectedValue === "state") {
            getLocationDemographicsByState()
        }
        if (selectedValue === "City" || selectedValue === "city") {
            getLocationDemographicsByCity()
        }
        //getInActiveDevicesTrend(selectedValue.toLowerCase())
    }

    function exportLocationData(){
        let filteredData
        if(selectedValue === "State"){
            filteredData = locationJsonResult.map((item) => ({
                State: item.state,
                Count: item.count

                // Assuming address is a nested object
            }));
        }
        if(selectedValue === "City"){
            filteredData = locationJsonResult.map((item) => ({
                City: item.city,
                Count: item.count

                // Assuming address is a nested object
            }));
        }

        let wb = utils.book_new(),
            ws = utils.json_to_sheet(filteredData);
        utils.book_append_sheet(wb, ws, "crompton_user_location_details")
        writeFile(wb, "crompton_user_location_details_" + getCurrentDate() +  ".xlsx")
    }

    return (
        <Card extra={"w-full h-full sm:overflow-auto px-6 !p-[20px]"}>
            <div className="flex justify-between">
                <h2 className="text-lg font-bold text-navy-700 dark:text-white">
                    Location Demographics
                </h2>
                <div className="mb-6 flex items-center justify-center">
                    <select id="stateCityBoxBarChart" onChange={handleStateCityDropDown}
                            className="mb-3 flex items-center justify-center text-sm font-bold text-gray-600 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white">
                        <option value="State">State</option>
                        <option value="City">City</option>
                    </select>
                    <button className=" mb-3 flex items-center justify-center text-sm font-bold text-gray-600 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white"
                            onClick={exportLocationData}>
                        Export Data
                    </button>
                </div>
            </div>

            {!isLoading &&
                <div>
                    <div className="mb-auto flex h-[300px] w-full items-center justify-center">
                        <PieChart options={{
                            labels: options,
                            colors: ["#9BBFE0", "#E8A09A", "#FBE29F", "#C6D68F", "#656565", "#FF9500", "#5ACF7A", "#5856D6", "#AF52DE", "#2085EC", "#72B4EB", "#8464A0", "#CE9ABC", "#C63848", "#7A3137", "#323642"],
                            chart: {
                                width: "50px",
                            },
                            states: {
                                hover: {
                                    filter: {
                                        type: "none",
                                    },
                                },
                            },
                            legend: {
                                show: false,
                            },
                            dataLabels: {
                                enabled: false,
                            },
                            hover: {mode: null},
                            plotOptions: {
                                donut: {
                                    expandOnClick: false,
                                    donut: {
                                        labels: {
                                            show: false,
                                        },
                                    },
                                },
                            },
                            fill: {
                                colors: ["#9BBFE0", "#E8A09A", "#FBE29F", "#C6D68F", "#656565", "#FF9500", "#5ACF7A", "#5856D6", "#AF52DE", "#2085EC", "#72B4EB", "#8464A0", "#CE9ABC", "#C63848", "#7A3137", "#323642"],
                            },
                            tooltip: {
                                enabled: true,
                                theme: "dark",
                                style: {
                                    fontSize: "12px",
                                    fontFamily: undefined,
                                    backgroundColor: "#000000"
                                },
                            },
                        }
                        } series={dataCount}/>
                    </div>
                    <div
                        className="flex flex-row !justify-between rounded-2xl px-6 py-3 shadow-2xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
                        <div className="flex flex-col items-center justify-center">
                            <div className="flex items-center justify-center">
                                <div className="h-2 w-2 rounded-full bg-[#9BBFE0]"/>
                                <p className="ml-1 text-sm font-normal text-gray-600">{unit[0]}</p>
                            </div>
                            <p className="mt-px text-xl font-bold text-navy-700  dark:text-white">
                                {(((pieChartDataValues[0] / (total)) * 100).toFixed(1)) + "%"}
                            </p>
                        </div>

                        <div className="h-11 w-px bg-gray-300 dark:bg-white/10"/>

                        <div className="flex flex-col items-center justify-center">
                            <div className="flex items-center justify-center">
                                <div className="h-2 w-2 rounded-full  bg-[#E8A09A]"/>
                                <p className="ml-1 text-sm font-normal text-gray-600">{unit[1]}</p>
                            </div>
                            <p className="mt-px text-xl font-bold text-navy-700  dark:text-white">
                                {(((pieChartDataValues[1] / (total)) * 100).toFixed(1)) + "%"}
                            </p>
                        </div>

                        <div className="h-11 w-px bg-gray-300 dark:bg-white/10"/>

                        <div className="flex flex-col items-center justify-center">
                            <div className="flex items-center justify-center">
                                <div className="h-2 w-2 rounded-full bg-[#FBE29F]"/>
                                <p className="ml-1 text-sm font-normal text-gray-600">{unit[2]}</p>
                            </div>
                            <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
                                {(((pieChartDataValues[2] / (total)) * 100).toFixed(1)) + "%"}
                            </p>
                        </div>

                        <div className="h-11 w-px bg-gray-300 dark:bg-white/10"/>

                        <div className="flex flex-col items-center justify-center">
                            <div className="flex items-center justify-center">
                                <div className="h-2 w-2 rounded-full bg-[#C6D68F]"/>
                                <p className="ml-1 text-sm font-normal text-gray-600">{unit[3]}</p>
                            </div>
                            <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
                                {(((pieChartDataValues[3] / (total)) * 100).toFixed(1)) + "%"}
                            </p>
                        </div>

                        <div className="h-11 w-px bg-gray-300 dark:bg-white/10"/>

                        <div className="flex flex-col items-center justify-center">
                            <div className="flex items-center justify-center">
                                <div className="h-2 w-2 rounded-full bg-[#656565]"/>
                                <p className="ml-1 text-sm font-normal text-gray-600">{unit[4]}</p>
                            </div>
                            <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
                                {(((pieChartDataValues[4] / (total)) * 100).toFixed(1)) + "%"}
                            </p>
                        </div>
                    </div>
                </div>
            }

        </Card>
    );
    /*<LocationDemographicsTrend
        columnsData={[
            {
                Header: "SR",
                accessor: "sr",
            },
            {
                Header: "STATE",
                accessor: "state",
            },
            {
                Header: "COUNT",
                accessor: "count",
            },
        ]}
        tableData={locationJsonResult}
    />*/

};

export default LocationDataStatePieChart;
